import * as i0 from '@angular/core';
import * as i1 from './accordion.module';
import * as i2 from '@angular/common';
import * as i3 from '../icon/icon.component';
import * as i4 from './accordion.component';
import * as i5 from './accordion-panel.component';
import * as i6 from './accordion-header.component';
import * as i7 from './accordion-icon-plus.components';
import * as i8 from './accordion-icon-arrow.components';
import * as i9 from '../icon/icon.module';
export const BllAccordionModuleNgFactory:i0.NgModuleFactory<i1.BllAccordionModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any,any> = (<any>(null as any));
var _decl0_3:i2.NgIf<any> = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.BllIconComponent = (<any>(null as any));
var _decl0_12:i4.BllAccordionComponent = (<any>(null as any));
var _decl0_13:i5.BllAccordionPanelComponent = (<any>(null as any));
var _decl0_14:i6.BllAccordionPanelHeaderComponent = (<any>(null as any));
var _decl0_15:i7.BllAccorionIconPlusComponent = (<any>(null as any));
var _decl0_16:i8.BllAccorionIconArrowComponent = (<any>(null as any));
var _decl0_17:i2.AsyncPipe = (<any>(null as any));
var _decl0_18:i2.UpperCasePipe = (<any>(null as any));
var _decl0_19:i2.LowerCasePipe = (<any>(null as any));
var _decl0_20:i2.JsonPipe = (<any>(null as any));
var _decl0_21:i2.SlicePipe = (<any>(null as any));
var _decl0_22:i2.DecimalPipe = (<any>(null as any));
var _decl0_23:i2.PercentPipe = (<any>(null as any));
var _decl0_24:i2.TitleCasePipe = (<any>(null as any));
var _decl0_25:i2.CurrencyPipe = (<any>(null as any));
var _decl0_26:i2.DatePipe = (<any>(null as any));
var _decl0_27:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_28:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_29:i2.KeyValuePipe = (<any>(null as any));
var _decl0_30:i2.CommonModule = (<any>(null as any));
var _decl0_31:i9.BllIconModule = (<any>(null as any));
var _decl0_32:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_33:i0.ElementRef<any> = (<any>(null as any));
function _View_BllAccordionComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_BllAccordionComponent_1_0():void {
  var _any:any = (null as any);
}
function _View_BllAccordionPanelComponent_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_13.isOpen;
  currVal_0;
  const currVal_1:any = (!_decl0_13.noDisabledClass && _decl0_13.disabled);
  currVal_1;
}
function _View_BllAccordionPanelComponent_2_1():void {
  if ((_decl0_13.paddingContent && !_decl0_13.iconArrow)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_13.iconSize;
    currVal_0;
  }
}
function _View_BllAccordionPanelComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_13.itemId;
  currVal_0;
  const currVal_1:any = _decl0_13.headerId;
  currVal_1;
  const currVal_2:any = _decl0_13._getExpandedState();
  currVal_2;
  const currVal_3:any = (_decl0_13.paddingContent && !_decl0_13.iconArrow);
  currVal_3;
  const pd_4:any = ((<any>_decl0_13._bodyAnimationDone(_any)) !== false);
}
function _View_BllAccordionPanelHeaderComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_BllAccordionPanelHeaderComponent_3_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_14.accordion.isOpen;
  currVal_0;
  const currVal_1:any = _decl0_14.iconSize;
  currVal_1;
  const currVal_2:any = 2;
  currVal_2;
  const currVal_3:any = _decl0_16.active;
  currVal_3;
  const currVal_4:any = _decl0_16.color;
  currVal_4;
  const currVal_5:any = _decl0_16._size;
  currVal_5;
  const currVal_6:any = _decl0_16._size;
  currVal_6;
  const pd_7:any = ((<any>(_decl0_14.accordion.isOpen = _any)) !== false);
}
function _View_BllAccordionPanelHeaderComponent_3_2():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_14.accordion.isOpen;
  currVal_0;
  const currVal_1:any = _decl0_14.iconSize;
  currVal_1;
  const currVal_2:any = _decl0_15.active;
  currVal_2;
  const currVal_3:any = _decl0_15.color;
  currVal_3;
  const currVal_4:any = _decl0_15._size;
  currVal_4;
  const currVal_5:any = _decl0_15._size;
  currVal_5;
  const pd_6:any = ((<any>(_decl0_14.accordion.isOpen = _any)) !== false);
}
function _View_BllAccordionPanelHeaderComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (!_decl0_14.accordion.noDisabledClass && _decl0_14.accordion.disabled);
  currVal_0;
  const currVal_1:any = _decl0_14.iconCenter;
  currVal_1;
  const currVal_2:any = _decl0_14.iconArrow;
  currVal_2;
  const currVal_3:any = _decl0_14.iconArrow;
  currVal_3;
  const currVal_4:any = true;
  currVal_4;
}
function _View_BllAccorionIconPlusComponent_Host_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_15.active;
  currVal_0;
  const currVal_1:any = _decl0_15.color;
  currVal_1;
  const currVal_2:any = _decl0_15._size;
  currVal_2;
  const currVal_3:any = _decl0_15._size;
  currVal_3;
}
function _View_BllAccorionIconPlusComponent_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'tw-h-full tw-left-1/2 tw--translate-x-px';
  currVal_0;
  const currVal_1:any = _decl0_15.classNames;
  currVal_1;
  const currVal_2:any = _decl0_15.thickness;
  currVal_2;
  const currVal_3:any = _decl0_15.active;
  currVal_3;
  const currVal_4:any = _decl0_15.active;
  currVal_4;
  const currVal_5:any = 'tw-w-full tw-top-1/2 tw--translate-y-px';
  currVal_5;
  const currVal_6:any = _decl0_15.classNames;
  currVal_6;
  const currVal_7:any = _decl0_15.thickness;
  currVal_7;
  const currVal_8:any = _decl0_15.active;
  currVal_8;
}
function _View_BllAccorionIconArrowComponent_Host_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_16.active;
  currVal_0;
  const currVal_1:any = _decl0_16.color;
  currVal_1;
  const currVal_2:any = _decl0_16._size;
  currVal_2;
  const currVal_3:any = _decl0_16._size;
  currVal_3;
}
function _View_BllAccorionIconArrowComponent_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'bll-accordion-arrow-left';
  currVal_0;
  const currVal_1:any = _decl0_16.classNames;
  currVal_1;
  const currVal_2:any = _decl0_16.borderBottom;
  currVal_2;
  const currVal_3:any = _decl0_16._size;
  currVal_3;
  const currVal_4:any = _decl0_16.thickness;
  currVal_4;
  const currVal_5:any = 'bll-accordion-arrow-right';
  currVal_5;
  const currVal_6:any = _decl0_16.classNames;
  currVal_6;
  const currVal_7:any = _decl0_16.thickness;
  currVal_7;
  const currVal_8:any = _decl0_16.borderBottom;
  currVal_8;
  const currVal_9:any = _decl0_16._size;
  currVal_9;
  const currVal_10:any = _decl0_16.thickness;
  currVal_10;
}
